import { render, staticRenderFns } from "./services.vue?vue&type=template&id=0e2f3f50"
import script from "./services.vue?vue&type=script&lang=ts"
export * from "./services.vue?vue&type=script&lang=ts"
import style0 from "./services.vue?vue&type=style&index=0&id=0e2f3f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports